import cx from "classnames";
import { twMerge } from "tailwind-merge";

export function GalleryImage({ src, alt, limitHeight, blur }: { src?: string; alt?: string; limitHeight?: boolean; blur?: boolean }) {
  return (
    <img
      src={src}
      alt={alt}
      className={twMerge(
        cx("object-cover z-10", {
          "max-h-[20svh]": limitHeight,
          "brightness-50 blur-xs scale-105 z-0 grow": blur,
        }),
      )}
    />
  );
}
